import { render } from "./DeleteWorkspaceModal.vue?vue&type=template&id=615d1d54&scoped=true&ts=true"
import script from "./DeleteWorkspaceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteWorkspaceModal.vue?vue&type=script&lang=ts"

import "./DeleteWorkspaceModal.vue?vue&type=style&index=0&id=615d1d54&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615d1d54"]])

export default __exports__